import React, { useRef, useState, useId } from "react";
import './MyAccountDashboard.scss';
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function MyAccountDashboard({ }) {
    const navigate = useNavigate();
    const location = useLocation()
    const url = new URL(window.location.href);
    let arr = Array.apply(null, { length: 10 }).map(Number.call, Number);

    useEffect(() => {
        // window.scrollBy({
        //     top: 330,
        //     behavior: 'smooth'
        //   });
    }, []);

    return (
        <div className="MyAccountDashboard">
            <div className="MyAccountProjectsHeader">
                <div className="MyAccountProjectsHeaderLeft">
                    <h1>Account Dashboard</h1>
                    <h2>View your profile, recent activity, and project history all in one place.</h2>
                </div>
                <img src={require(`../../../Images/3d-house.png`)} alt="Chimney Cleaning" />
            </div>
        </div >
    )
}

